function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  id: "outline",
  fillRule: "nonzero",
  d: "M12.6128994,2.12391817 L12.7071068,2.20710678 L21,10.5 L21,21 C21,21.5128358 20.6139598,21.9355072 20.1166211,21.9932723 L20,22 L13,22 L13,18 L11,18 L11,22 L4,22 C3.48716416,22 3.06449284,21.6139598 3.00672773,21.1166211 L3,21 L3,10.5 L11.2928932,2.20710678 C11.6533772,1.84662282 12.2206082,1.81889328 12.6128994,2.12391817 Z M12,4.329 L5,11.328 L5,20 L9,20 L9,16 L15,16 L15,20 L19,20 L19,11.329 L12,4.329 Z"
});

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  id: "fill",
  fillRule: "nonzero",
  points: "12 4.329 5 11.328 5 20 9 20 9 16 15 16 15 20 19 20 19 11.329"
});

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBpZD0ib3V0bGluZSIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMTIuNjEyODk5NCwyLjEyMzkxODE3IEwxMi43MDcxMDY4LDIuMjA3MTA2NzggTDIxLDEwLjUgTDIxLDIxIEMyMSwyMS41MTI4MzU4IDIwLjYxMzk1OTgsMjEuOTM1NTA3MiAyMC4xMTY2MjExLDIxLjk5MzI3MjMgTDIwLDIyIEwxMywyMiBMMTMsMTggTDExLDE4IEwxMSwyMiBMNCwyMiBDMy40ODcxNjQxNiwyMiAzLjA2NDQ5Mjg0LDIxLjYxMzk1OTggMy4wMDY3Mjc3MywyMS4xMTY2MjExIEwzLDIxIEwzLDEwLjUgTDExLjI5Mjg5MzIsMi4yMDcxMDY3OCBDMTEuNjUzMzc3MiwxLjg0NjYyMjgyIDEyLjIyMDYwODIsMS44MTg4OTMyOCAxMi42MTI4OTk0LDIuMTIzOTE4MTcgWiBNMTIsNC4zMjkgTDUsMTEuMzI4IEw1LDIwIEw5LDIwIEw5LDE2IEwxNSwxNiBMMTUsMjAgTDE5LDIwIEwxOSwxMS4zMjkgTDEyLDQuMzI5IFoiLz48cG9seWdvbiBpZD0iZmlsbCIgZmlsbC1ydWxlPSJub256ZXJvIiBwb2ludHM9IjEyIDQuMzI5IDUgMTEuMzI4IDUgMjAgOSAyMCA5IDE2IDE1IDE2IDE1IDIwIDE5IDIwIDE5IDExLjMyOSIvPjwvc3ZnPgo=";
export { SvgHome as ReactComponent };